import { ISeriesWithEvents } from '@/types/series.types';
import { Get } from '../helpers';
import { SeriesPath } from './path';

export default function LoadSeriesFull({ channel, seriesUuid }: { channel: number; seriesUuid: string }) {
  return Get<ISeriesWithEvents>({
    path: SeriesPath(channel, `/${seriesUuid}`),
  });
}
